import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[100svh] md:min-h-[600px] md:h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-91">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/ovf1erJfvgC2xgbFToN3vZ/quiero_que_me_202604161701.jpg")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-92">
        <div className="absolute inset-0 bg-gradient-to-b from-cabbage-dark/70 via-cabbage-dark/40 to-cream" data-id="element-93"></div>
      </div>

      <div className="relative z-10 container mx-auto px-5 md:px-6 text-center flex flex-col items-center pt-12 md:pt-20" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="max-w-4xl" data-id="element-95">
          <span className="block text-gold-light font-sans tracking-[0.15em] md:tracking-[0.2em] uppercase text-xs md:text-base mb-3 md:mb-4 font-medium" data-id="element-96">
            La Guía Definitiva
          </span>
          <h1 className="text-5xl md:text-8xl lg:text-9xl font-serif text-white mb-4 md:mb-6 drop-shadow-lg italic" data-id="element-97">
            Repollo
          </h1>
          <h2 className="text-xl md:text-4xl font-serif text-cream-light mb-5 md:mb-8 font-light leading-snug" data-id="element-98">
            Ensaladas de verano, recetas, encurtidos y batidos
          </h2>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.5,
          duration: 1
        }} className="text-base md:text-xl text-cream max-w-2xl mx-auto mb-8 md:mb-12 font-light leading-relaxed" data-id="element-99">
            Descubre con más de{' '}
            <strong className="font-semibold text-gold-light" data-id="element-100">
              60 recetas variadas
            </strong>{' '}
            todos sus beneficios y delicioso sabor.
          </motion.p>

          <motion.button initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.8,
          duration: 0.8
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-leaf hover:bg-leaf-dark text-white px-6 py-3 md:px-8 md:py-4 rounded-full font-sans font-medium transition-colors shadow-xl flex flex-col items-center mx-auto" onClick={() => document.getElementById('cta')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-101">
            <span className="text-xs text-white/70 line-through mb-0.5" data-id="element-102">
              Antes 8,99 €
            </span>
            <span className="text-base md:text-lg flex items-center gap-2" data-id="element-103">
              Quiero las recetas — 4,99 € <ArrowDown size={18} data-id="element-104" />
            </span>
          </motion.button>
        </motion.div>
      </div>
    </section>;
}